import { useEffect } from 'react';
import { supabase } from '@/integrations/supabase/client';
import { toast } from 'sonner';

interface UseRealTimeGameUpdatesProps {
  onGameStatusUpdate?: () => void;
  userId?: string;
}

export const useRealTimeGameUpdates = ({ onGameStatusUpdate, userId }: UseRealTimeGameUpdatesProps) => {
  useEffect(() => {
    if (!userId) return;

    // Subscribe to venue_games changes for real-time updates
    const channel = supabase
      .channel('venue-games-changes')
      .on(
        'postgres_changes',
        {
          event: 'UPDATE',
          schema: 'public',
          table: 'venue_games'
        },
        (payload) => {
          console.log('Game status updated:', payload);
          
          // Check if this update affects the current user's teams
          const gameData = payload.new;
          if (gameData.status === 'approved' && gameData.game_status === 'confirmed') {
            toast.success('Game confirmed! Check your game management dashboard.');
            onGameStatusUpdate?.();
          } else if (gameData.status === 'rejected') {
            toast.error('Game request was rejected.');
            onGameStatusUpdate?.();
          }
        }
      )
      .on(
        'postgres_changes',
        {
          event: 'INSERT',
          schema: 'public',
          table: 'game_notifications'
        },
        (payload) => {
          console.log('New game notification:', payload);
          
          // Check if this notification is for the current user
          const notification = payload.new;
          if (notification.recipient_id === userId) {
            toast.info('New game notification received!');
            onGameStatusUpdate?.();
          }
        }
      )
      .subscribe();

    return () => {
      supabase.removeChannel(channel);
    };
  }, [userId, onGameStatusUpdate]);
};